import React, { useContext } from "react";
import commonContext from "../../../context/common";

function DisbursementCard() {
    const { lead, utils, base } = useContext(commonContext);
    return (
        <>
            <div className="relative w-full">
                <div className="relative w-full md:w-1/2 lg:w-1/2 xl:w-1/2 rounded-lg lighter-blue-2 px-3 py-3 md:px-5 md:py-5 xl:px-8 xlpy-8 my-6 md:my-8">
                    <h3 className="w-full md:w-10/12 openSans-Reg text-black text-2xl md:text-3xl lg:text-4xl mb-5">
                        Total Disbursement Amount
                    </h3>
                    <div className="w-full">
                        <div className="w-full flex flex-wrap items-center mb-3">
                            <div className="w-full flex flex-wrap items-center mb-3">
                                <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                    Desired Amount
                                </p>
                                <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                    <span className="WebRupee">Rs.</span>
                                    <span>
                                        {utils.currencyFormat(
                                            lead.desiredLoanAmount
                                        )}
                                    </span>{" "}
                                </p>
                            </div>
                            {lead.roadTaxInsuranceAvailed ? (
                                <>
                                    <div className="w-full flex flex-wrap items-center mb-3">
                                        <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                            Road Tax
                                        </p>
                                        <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                            +{" "}
                                            <span className="WebRupee">
                                                Rs.
                                            </span>
                                            <span>
                                                {utils.currencyFormat(
                                                    parseFloat(
                                                        lead.rtoEditAmount
                                                    )
                                                )}
                                            </span>{" "}
                                        </p>
                                    </div>
                                </>
                            ) : (
                                ""
                            )}
                            {lead.motorInsuranceAvailed ? (
                                <>
                                    <div className="w-full flex flex-wrap items-center mb-3">
                                        <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                            {base == "qm-10-seconds"
                                                ? "HDFC Motor Insurance"
                                                : "HDFC ERGO Insurance"}
                                        </p>
                                        <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                            +{" "}
                                            <span className="WebRupee">
                                                Rs.
                                            </span>
                                            <span>
                                                {utils.currencyFormat(
                                                    parseFloat(
                                                        lead.motorInsurancePremium
                                                    )
                                                )}
                                            </span>{" "}
                                        </p>
                                    </div>
                                </>
                            ) : (
                                ""
                            )}
                            {lead.dealerInsuranceAvailed ? (
                                <>
                                    <div className="w-full flex flex-wrap items-center mb-3">
                                        <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                            Dealer Insurance
                                        </p>
                                        <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                            +{" "}
                                            <span className="WebRupee">
                                                Rs.
                                            </span>
                                            <span>
                                                {utils.currencyFormat(
                                                    parseFloat(
                                                        lead.dealerInsuranceAmtEdit
                                                    )
                                                )}
                                            </span>{" "}
                                        </p>
                                    </div>
                                </>
                            ) : (
                                ""
                            )}
                            {lead.insuranceAvailed ? (
                                <>
                                    <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                        Sarv Surksha Premium
                                    </p>
                                    <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                        + <span className="WebRupee">Rs.</span>
                                        <span>
                                            {utils.currencyFormat(
                                                parseFloat(
                                                    lead.insuranceSsiPremium
                                                )
                                            )}
                                        </span>{" "}
                                    </p>
                                </>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="w-full flex flex-wrap items-center mb-3">
                            <div className="w-full flex flex-wrap items-center mb-3">
                                <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                    <b>Total Loan Amount</b>
                                </p>
                                <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                    <span className="WebRupee">Rs.</span>
                                    <span>
                                        {utils.currencyFormat(
                                            lead.totalLoanAmount
                                        )}
                                    </span>{" "}
                                </p>
                            </div>
                            {lead.motorInsuranceAvailed ? (
                                <>
                                    <div className="w-full flex flex-wrap items-center mb-3">
                                        <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                            {base == "qm-10-seconds"
                                                ? "HDFC Motor Insurance"
                                                : "HDFC ERGO Insurance"}
                                        </p>
                                        <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                            -{" "}
                                            <span className="WebRupee">
                                                Rs.
                                            </span>
                                            <span>
                                                {utils.currencyFormat(
                                                    parseFloat(
                                                        lead.motorInsurancePremium
                                                    )
                                                )}
                                            </span>{" "}
                                        </p>
                                    </div>
                                </>
                            ) : (
                                ""
                            )}

                            {lead.insuranceAvailed ? (
                                <>
                                    <div className="w-full flex flex-wrap items-center mb-3">
                                        <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                            Sarv Surksha Premium
                                        </p>
                                        <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                            -{" "}
                                            <span className="WebRupee">
                                                Rs.
                                            </span>
                                            <span>
                                                {utils.currencyFormat(
                                                    parseFloat(
                                                        lead.insuranceSsiPremium
                                                    )
                                                )}
                                            </span>{" "}
                                        </p>
                                    </div>
                                </>
                            ) : (
                                ""
                            )}

                            <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-gray-500">
                                Bank Charges
                            </p>
                            <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                -<span className="WebRupee">Rs.</span>
                                <span>
                                    {utils.currencyFormat(
                                        parseFloat(lead.stampDuty) +
                                            parseFloat(lead.processingFees) +
                                            lead.collateralCharges
                                    )}
                                </span>
                            </p>
                        </div>
                        <div className="w-full border-t lightborder py-3">
                            <div className="w-full flex flex-wrap items-center">
                                <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-black">
                                    Total Amount
                                </p>
                                <p className="w-1/2 text-right openSans-SemiBold text-black text-2xl md:text-2xl lg:text-3xl relative pl-4">
                                    <span className="WebRupee">Rs.</span>
                                    <span>
                                        {utils.currencyFormat(lead.totalAmount)}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DisbursementCard;
